import { AngularServices } from '../../../../../modules/core';
import { OT_ERRORS } from '../errors-types';
import { PublisherErrorHandler } from '../publisher-error-handler';
export default class OtConstraintNotSatisfiedErrorHandler extends PublisherErrorHandler {
    constructor() {
        super(...arguments);
        this.errorName = OT_ERRORS.CONSTRAINTS_NOT_SATISFIED;
    }
    get activeProvider() {
        return this.$injector.get(AngularServices.VideoProviderFactory)
            .activeProvider;
    }
    onError(err) {
        this.debug('onError', err, this.isFixApplied);
        if (this.isFixApplied) {
            this.notify({ isFixed: false });
        }
        else {
            this.handleFix();
        }
    }
    handleFix() {
        this.isFixApplied = true;
        this.activeProvider.clearCurrentDevices();
        void this.activeProvider.enableWebcam();
    }
}
